// =============================================================================
// TestLabBoard — shared "Quick Board" for the Test Lab UI
// =============================================================================
// A single (singleton) document holding the team-shared:
//   - pinned important links (e.g. ClickUp, dashboards)
//   - SOS / urgent tasks (to-do list)
//
// Stored as one JSON blob (`dataJSON`) for flexibility — shape:
//   { links: [{ title, url }], tasks: [{ id, text, done }] }
//
// Shared across all testers (admin-gated via requireTestLabAccess in the
// resolvers). Last-write-wins; no per-field locking (low contention).
// =============================================================================

import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class TestLabBoard extends MongoEntity {
  static override _class = 'TestLabBoard';
  static override _collectionName = 'test_lab_board';

  constructor(data: PartialEntityData<TestLabBoard>) {
    super(data);
  }

  /** Fixed key for the singleton board document. */
  @Field(() => String) boardKey: Maybe<string>;
  /** JSON-stringified { links: [{title,url}], tasks: [{id,text,done}] }. */
  @Field(() => String) dataJSON: Maybe<string>;
  /** When the board was last saved. */
  @Field(() => Date) updatedAt: Maybe<Date>;
}
